import React from 'react';
import {Box, Typography} from '@mui/material';
import PartnerDashboardShell from '../components/PartnerDashboard.comp';
import CoverageOverviewTab from '../tabs/CoverageOverview.tab';

const NAVY = '#052F44';

/* ── Main page ──────────────────────────────────────────────────── */
const ParticipationCoveragePage = () => {
    return (
        <PartnerDashboardShell>

            {/* Title */}
            <Box sx={{display: 'flex', alignItems: 'flex-start', justifyContent: 'space-between', flexWrap: 'wrap', gap: 1, mb: 0.5, mt: 1.5}}>
                <Typography sx={{fontSize: '23px', fontWeight: 800, color: NAVY}}>
                    Participation Overview
                </Typography>
            </Box>

            {/* Decision question */}
            <Box sx={{display: 'flex', alignItems: 'baseline', gap: 1, mb: 3}}>
                <Typography sx={{fontSize: '14px', fontStyle: 'italic', color: '#4B5563'}}>
                    Where is reach strong, weak, or inequitable?
                </Typography>
            </Box>

            {/*
              * P1 Partner Dashboard deck, slide 20:
              *   "Do not present countries' figures as representatives
              *    until coverage rises above 50%"
              *
              * A caveat rather than a filter. The threshold governs how a reader
              * should USE a country row, not whether the row exists — hiding
              * under-covered countries would leave a partner unable to see where
              * coverage is thin, which is the point of this page. Stated once,
              * above the table, in the same "use with care" treatment the Cyber
              * Risks overview uses for its own caveat.
              */}
            <Box sx={{
                backgroundColor: 'rgba(217, 119, 6, 0.06)',
                borderLeft: '4px solid #D97706',
                borderRadius: '0 8px 8px 0',
                p: 2,
                mb: 3,
            }}>
                <Typography sx={{fontSize: '13px', color: '#374151', lineHeight: 1.7}}>
                    <strong style={{color: '#D97706'}}>Read coverage first.&nbsp;</strong>
                    Do not present a country&rsquo;s figures as representative until coverage
                    rises above 50%. Below that, the numbers describe the schools that took
                    part, not the country.
                </Typography>
            </Box>

            <CoverageOverviewTab/>

        </PartnerDashboardShell>
    );
};

export default ParticipationCoveragePage;
